import PropTypes from "prop-types";
import React from "react";
import { formatCents } from "../../../shared/formattingUtils";

const dollarsToCents = (v) => Math.round(Number(v) * 100);

const seatDescription = (seat) =>
  [
    seat.section && `Section ${seat.section}`,
    seat.row && `Row ${seat.row}`,
    seat.seat && `Seat ${seat.seat}`,
  ]
    .filter(Boolean)
    .join(" · ");

const BundleBreakdown = ({ bundle, title, capPercentage }) => {
  if (!bundle) return null;

  const gaCents = dollarsToCents(bundle.admission.cost);
  const seatCents = dollarsToCents(bundle.seat_add_on.cost);
  const totalCents = gaCents + seatCents;
  const seat = bundle.seat_add_on;

  const capNote =
    capPercentage != null && Number.isFinite(capPercentage) && capPercentage > 0
      ? ` — caps resale at ${capPercentage}% (${formatCents(
          Math.floor((totalCents * capPercentage) / 100),
        )})`
      : "";

  return (
    <div className="resale-bundle-group" data-testid="bundle-breakdown">
      <div className="resale-bundle-group-head">
        <span className="resale-bundle-group-title">{title || bundle.admission.name}</span>
        <span className="resale-bundle-tag">Grouped together</span>
      </div>
      <div className="resale-bundle-group-item">
        <div className="resale-bundle-item-main">
          <span className="resale-bundle-item-name">{bundle.admission.name}</span>
          <span className="resale-bundle-item-desc">Admission ticket</span>
        </div>
        <span className="resale-bundle-item-amt">{formatCents(gaCents)}</span>
      </div>
      <div className="resale-bundle-group-item">
        <div className="resale-bundle-item-main">
          <span className="resale-bundle-item-name">{seat.label}</span>
          <span className="resale-bundle-item-desc">{seatDescription(seat)}</span>
        </div>
        <span className="resale-bundle-item-amt">{formatCents(seatCents)}</span>
      </div>
      <div className="resale-bundle-group-sub">
        Original price paid: <strong>{formatCents(totalCents)}</strong>
        {capNote}
      </div>
    </div>
  );
};

BundleBreakdown.propTypes = {
  bundle: PropTypes.shape({
    admission: PropTypes.shape({ name: PropTypes.string, cost: PropTypes.number }),
    seat_add_on: PropTypes.shape({
      label: PropTypes.string,
      section: PropTypes.string,
      row: PropTypes.string,
      seat: PropTypes.string,
      cost: PropTypes.number,
    }),
  }),
  title: PropTypes.string,
  capPercentage: PropTypes.number,
};

export default BundleBreakdown;
